import { render, staticRenderFns } from "./model1.vue?vue&type=template&id=f0afdb2e&scoped=true"
import script from "./model1.vue?vue&type=script&lang=js"
export * from "./model1.vue?vue&type=script&lang=js"
import style0 from "./model1.vue?vue&type=style&index=0&id=f0afdb2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0afdb2e",
  null
  
)

export default component.exports